(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sr-page-music"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sr-page-music')) {
  customElements.define('sr-page-music', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.options = {signal:this.controller.signal};
      this.audio = this.querySelector('audio');
      this.audio.volume = 0.35;
      this.buttons = new Map();
      this.enabled = false;
      this.pending = false;
      this.activeTarget = null;
      this.visibleTargets = new Set();
      this.seekedStart = false;
      const seekStart = () => {
        if (this.seekedStart) return;
        this.audio.currentTime = 23;
        this.seekedStart = true;
      };
      this.audio.addEventListener('loadedmetadata',seekStart,this.options);
      if (this.audio.readyState >= 1) seekStart();
      this.paint = () => this.buttons.forEach((target,button) => {
        const on = this.enabled && target === this.activeTarget;
        const label = on ? this.dataset.pause : this.dataset.play;
        if (button.textContent !== label) button.textContent = label;
        button.setAttribute('aria-pressed',String(on));
      });
      this.stop = () => {
        this.enabled = false;
        this.audio.pause();
        this.paint();
      };
      this.inMusicArea = () => {
        if (this.dataset.page !== 'index') return this.visibleTargets.has(this.activeTarget);
        const videos = document.querySelectorAll('.sr-product-grid .sr-card-video, .sr-package-reveal video');
        const lastVideo = videos[videos.length - 1];
        return !!lastVideo && lastVideo.getBoundingClientRect().bottom > 0;
      };
      this.shouldPlay = () => this.enabled && this.inMusicArea() && !document.hidden;
      this.sync = () => {
        if (!this.shouldPlay()) { this.audio.pause(); return; }
        if (this.audio.paused && !this.pending) this.play();
      };
      this.play = () => {
        this.pending = true;
        this.audio.play().then(() => {
          this.pending = false;
          if (!this.shouldPlay()) this.audio.pause();
          this.paint();
        }).catch(error => {
          this.pending = false;
          if (error.name === 'AbortError') this.sync();
          else this.stop();
        });
      };
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.15) this.visibleTargets.add(entry.target);
          else this.visibleTargets.delete(entry.target);
        });
        this.sync();
      },{threshold:[0,0.15]});
      this.addButton = (target,host,isHome) => {
        if (host.querySelector('.sr-music-toggle')) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sr-music-toggle' + (isHome ? '' : ' sr-music-video-control');
        button.textContent = this.dataset.play;
        button.setAttribute('aria-pressed','false');
        button.addEventListener('click',event => {
          event.preventDefault();
          event.stopPropagation();
          if (this.enabled && this.activeTarget === target) { this.stop(); return; }
          this.activeTarget = target;
          this.enabled = true;
          if (this.audio.ended) this.audio.currentTime = 23;
          this.paint();
          if (!this.pending) this.play();
        },this.options);
        this.buttons.set(button,target);
        host.appendChild(button);
        if (!isHome) this.observer.observe(target);
      };
      this.scan = () => {
        this.buttons.forEach((target,button) => {
          if (!target.isConnected) {
            if (target === this.activeTarget) this.stop();
            this.observer.unobserve(target);
            button.remove();
            this.buttons.delete(button);
          }
        });
        if (this.dataset.page === 'index') {
          const grid = document.querySelector('.sr-product-grid');
          const hero = document.querySelector('.sr-home-hero');
          if (!grid || !hero || [...this.buttons.values()].includes(grid)) return;
          const host = document.createElement('div');
          host.className = 'sr-music-home-control';
          hero.appendChild(host);
          this.addButton(grid,host,true);
        } else {
          document.querySelectorAll('#MainContent video').forEach(video => {
            const host = video.closest('[data-sr-loop-video], .product-media') || video.parentElement;
            if (!host) return;
            host.classList.add('sr-music-video-host');
            this.addButton(video,host,false);
          });
        }
      };
      this.scan();
      if (this.dataset.page === 'index') {
        this.onScroll = () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            this.sync();
          });
        };
        window.addEventListener('scroll',this.onScroll,{...this.options,passive:true});
        window.addEventListener('resize',this.onScroll,this.options);
      }
      this.mutations = new MutationObserver(() => this.scan());
      this.mutations.observe(document.querySelector('#MainContent'),{childList:true,subtree:true});
      this.audio.addEventListener('ended',() => {
        this.audio.currentTime = 23;
        this.sync();
      },this.options);
      this.audio.addEventListener('error',this.stop,this.options);
      document.addEventListener('visibilitychange',() => {
        this.sync();
      },this.options);
      window.addEventListener('pagehide',this.stop,this.options);
    }
    disconnectedCallback() {
      this.audio?.pause();
      this.observer?.disconnect();
      this.mutations?.disconnect();
      this.controller?.abort();
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.buttons?.forEach((target,button) => {
        const host = button.parentElement;
        button.remove();
        if(host?.classList.contains('sr-music-home-control')) host.remove();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sr-product-video-loop"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sr-product-video-loop')) {
  customElements.define('sr-product-video-loop', class extends HTMLElement {
    connectedCallback() {
      const normalize = value => {
        try { const u = new URL(value,location.href); return u.pathname.split('/').slice(-2).join('/'); } catch { return ''; }
      };
      const allowed = new Set(this.dataset.sources.split('|').filter(Boolean).map(normalize));
      if (!allowed.size) return;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.players = new Set();
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.2 && !document.hidden && !reduced.matches) video.play().catch(() => {});
          else video.pause();
        });
      },{threshold:[0,0.2]});
      this.scan = () => {
        document.querySelectorAll('#MainContent iframe[src*="pwzcdn.com/"]').forEach(frame => {
          let payload;
          try {
            const url = new URL(frame.src);
            if (url.hostname !== 'pwzcdn.com' || !url.pathname.endsWith('/video-player/index.html')) return;
            payload = JSON.parse(url.searchParams.get('payload'));
          } catch { return; }
          const source = payload.sources?.find(s => s.mimeType === 'video/mp4' && allowed.has(normalize(s.url)));
          if (!source) return;
          const parent = frame.parentElement;
          const video = document.createElement('video');
          video.src = new URL(source.url,location.href).href;
          video.poster = payload.poster || '';
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          video.controls = false;
          video.loop = true;
          video.preload = 'none';
          video.setAttribute('aria-label',frame.title);
          video.style.cssText = 'position:absolute;inset:0;display:block;width:100%;height:100%;object-fit:contain;background:#000';
          parent.dataset.srLoopVideo = 'true';
          frame.replaceWith(video);
          this.players.add(video);
          this.observer.observe(video);
        });
        this.players.forEach(video => {
          if (!video.isConnected) { video.pause(); this.observer.unobserve(video); this.players.delete(video); }
        });
      };
      this.scan();
      this.mutations = new MutationObserver(() => {
        if (this.queued) return;
        this.queued = true;
        queueMicrotask(() => { this.queued = false; if(this.isConnected) this.scan(); });
      });
      this.mutations.observe(document.querySelector('#MainContent'),{childList:true,subtree:true});
      this.controller = new AbortController();
      document.addEventListener('visibilitychange',() => {
        if (document.hidden) this.players.forEach(v => v.pause());
      },{signal:this.controller.signal});
    }
    disconnectedCallback() {
      this.players?.forEach(v => v.pause());
      this.observer?.disconnect();
      this.mutations?.disconnect();
      this.controller?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
